export const SHOW_LOGIN_MODAL = 'evite/*/LOGIN_MODAL/SHOW';
export const HIDE_LOGIN_MODAL = 'evite/*/LOGIN_MODAL/HIDE';
export const USER_LOGGED_IN = 'evite/*/LOGIN_MODAL/USER_LOGGED_IN';
